<template>
    <div class="QuestionDetails_wrap">
        <div class="QuestionDetails">
            <!--上面部分-->
            <div class="question_top_wrap">
                <div class="question_top_main">
                    <div class="top_nav">
                        <p class="jump_text">首页</p>
                        <span @click="toIndex">></span>
                        <p @click="pageJump(detailsData.firstcode, detailsData.firstcodename)"
                           v-if="detailsData.firstcodename !== ''" class="jump_text">{{detailsData.firstcodename}}</p>
                        <span v-if="detailsData.firstcodename !== ''">></span>
                        <p @click="pageJump(detailsData.secondcode, detailsData.secondcodename)"
                           v-if="detailsData.secondcodename !== ''" class="jump_text">{{detailsData.secondcodename}}</p>
                        <span v-if="detailsData.secondcodename !== ''">></span>
                        <p>{{detailsData.subject}}</p>
                    </div>
                    <div class="top_info">
                        <div class="top_left"><img :src="detailsData.coverurl" alt=""></div>
                        <div class="top_right">
                            <div class="queInfo_box">
                                <p class="title">{{detailsData.subject}}</p>
                                <p class="subTitle" v-if="detailsData.description">{{detailsData.description}}</p>
                                <div class="coupon" v-if="detailsData.couponvoucherlist && detailsData.couponvoucherlist.length">
                                    <div class="name">优惠券</div>
                                    <div class="list">
                                        <div class="getLabel">领券</div>
                                        <div class="item" @click="getCoupon(item, index)" v-show="item.inventory"  v-for="(item, index) in detailsData.couponvoucherlist" :key="index">
                                            {{item.prefercontent}}
                                        </div>
                                    </div>
                                </div>
                                <div v-if="!detailsData.islimitcount || detailsData.isbuy">
                                    <p class="money">
                                        <b v-if="detailsData.feetype === 1">¥ 免费</b>
                                        <span v-if="detailsData.feetype === 2">¥{{detailsData.saleprice}} <span class="uprice">¥{{detailsData.uprice}}</span></span>
                                    </p>
                                    <el-button @click="joinQuestion" v-if="detailsData.feetype === 1 && detailsData.isjoin === 0" type="danger"> 立即参与</el-button>
                                    <el-button @click="clickTestPaperPopu" v-if="detailsData.isjoin === 1" type="danger">进入考试</el-button>
                                    <el-button @click="buyNow" v-if="detailsData.feetype === 2 && detailsData.isjoin === 0" type="danger">立即购买</el-button>
                                </div>
                                <div v-else class="limit-time">
                                    <div class="limit-time-header">
                                        <div class="left">
                                            <i class="icon icon-course-time"></i>
                                            <span>{{detailsData.tagname?detailsData.tagname:'限时秒杀价'}}</span>
                                        </div>
                                        <div class="right">
                                            <span class="sepa-r" v-if="timer.day">{{timer.day}}天</span>
                                            <span class="time-box sepa-l sepa-r">{{timer.hour}}</span>:
                                            <span class="time-box sepa-l sepa-r">{{timer.minute}}</span>:
                                            <span class="time-box sepa-l">{{timer.second}}</span>
                                        </div>
                                    </div>
                                    <div class="bg-limit-time">
                                        <div class="limit-time-body">
                                            <span class="label">秒杀价</span>
                                            <span class="saleprice">¥{{detailsData.saleprice}}</span>
                                            <span class="uprice">¥{{detailsData.uprice}}</span>
                                        </div>
                                        <div class="limit-time-footer">
                                            <el-button @click="buyNow" v-if="detailsData.feetype === 2 && detailsData.isjoin === 0" type="danger">立即购买</el-button>
                                            <el-button @click="clickTestPaperPopu" v-if="detailsData.isjoin === 1" type="danger">进入考试</el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="right_bottom_box">
                                <span>已有{{detailsData.joincount}}人参与</span>
                                <span class="line">｜</span>
                                <el-popover
                                        placement="top"
                                        width="106"
                                        trigger="hover">
                                    <div class="icon_popover_box">
                                        <div id="qrcodeUrl"></div>
                                        <p>扫码手机分享</p>
                                    </div>
                                    <span class="icon_box cursor_class" slot="reference">
                                        <img :src="require('@/common/images/other/share_icon.png')" alt="">
                                        <span>分享</span>
                                    </span>
                                </el-popover>
                                <span class="line">｜</span>
                                <el-popover
                                        placement="top"
                                        width="106"
                                        trigger="hover">
                                    <div class="icon_popover_box">
                                        <div id="qrcodeUrl2"></div>
                                        <p>扫码手机学习</p>
                                    </div>
                                    <span class="icon_box cursor_class" slot="reference">
                                        <img :src="require('@/common/images/other/phone_icon.png')" alt="">
                                        <span>手机参与</span>
                                    </span>
                                </el-popover>
                                <span class="line">｜</span>
                                <span @click="collectionClick(detailsData.isfavorite)"
                                      :class="detailsData.isfavorite === 1 ? 'is_enshrine':''"
                                      class="cursor_class enshrine"><img
                                        :src="detailsData.isfavorite === 1 ? require('@/common/images/other/y_enshrine.png') : require('@/common/images/other/n_enshrine.png')"
                                        alt="">{{detailsData.isfavorite === 0 ? '添加' : '取消'}}收藏</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--下面部分-->
            <div class="question_bottom_wrap">
                <div class="bottom_box">
                    <div class="bottom_left">
                        <!--单试卷-->
                        <div class="que_main" v-if="detailsData.qbtype===1">
                            <div class="tabs_box">
                                <div @click="menuClick(1)" :class="menuIndex === 1 ? 'active' : ''">题库介绍</div>
                                <div @click="menuClick(3)" v-if="detailsData.ishavedoc" :class="{'active': menuIndex === 3 ? true : false, 'menuIndex3':true}">资料<span v-if="material.length > 0">{{material.length}}</span></div>
                            </div>
                            <!-- 题库介绍 -->
                            <div class="introduce_warp" v-show="menuIndex === 1">
                                <div v-if="detailsData.content === ''" class="no_data_box" >
                                    <img :src="require('@/common/images/other/no_data.png')" alt="">
                                    <span>当前题库暂无介绍</span>
                                </div>
                                <div v-else class="introduce_box" v-html="detailsData.content"></div>
                            </div>
                            <!-- 资料 -->
                            <div v-show="menuIndex === 3" class="course_tabs_item_box data_warp">
                                <div class="material_item" v-for="(item, index) in material" :key="index">
                                    <div class="material_item_name">{{item.docname}}</div>
                                    <div class="material_item_btn" v-if="detailsData.isjoin">
                                        <div class="box" @click="download(item)">
                                            <img :src="require('@/common/images/other/download.png')" alt="">
                                            <span>下载资料</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--系列试卷-->
                        <div class="que_main" v-if="detailsData.qbtype===2">
                            <div class="tabs_box">
                                <div @click="menuClick(1)" :class="menuIndex === 1 ? 'active' : ''">题库介绍</div>
                                <div @click="menuClick(2)" :class="menuIndex === 2 ? 'active' : ''">章节目录</div>
                                <div @click="menuClick(3)" v-if="detailsData.ishavedoc" :class="{'active': menuIndex === 3 ? true : false, 'menuIndex3':true}">资料<span v-if="material.length > 0">{{material.length}}</span></div>
                            </div>
                            <!--题库介绍-->
                            <div v-show="menuIndex === 1" class="course_tabs_item_box introduce_warp">
                                <div v-if="detailsData.content === ''" class="no_data_box">
                                    <img :src="require('@/common/images/other/no_data.png')" alt="">
                                    <span>当前题库暂无介绍</span>
                                </div>
                                <div v-else class="introduce_box" v-html="detailsData.content"></div>
                            </div>
                            <!--章节目录-->
                            <div v-show="menuIndex === 2" class="course_tabs_item_box cata_warp">
                                <div v-if="chapterData&&chapterData.length === 0" class="no_data_box">
                                    <img :src="require('@/common/images/other/no_data.png')" alt="">
                                    <span>当前题库暂无目录</span>
                                </div>
                                <!--章节列表-->
                                <div class="cata_box">
                                    <el-collapse class="outside" v-model="activeNames">
                                        <el-collapse-item class="outsideItem" :name="index" v-for="(item, index) in chapterData" :key="index">
                                            <template slot="title">
                                                <div class="itemTitle">
                                                    <img :src="activeNames.indexOf(index) === -1 ? require('@/common/images/personal/pack_up.svg') : require('@/common/images/personal/unfold.svg')" alt="">
                                                    <span >{{item.sectionname}}</span>
                                                </div>
                                            </template>
                                            <div v-for="(obj, i) in item.taskinfolist" :key="i">
                                                <el-collapse class="inside" v-model="item.activeNames">
                                                    <el-collapse-item :name="i">
                                                        <template slot="title">
                                                            <div class="insideItemTitle">
                                                                <div class="left">
                                                                    <img v-if="obj.childrenlist.length" :src="item.activeNames.indexOf(i) === -1 ? require('@/common/images/personal/pack_up.svg') : require('@/common/images/personal/unfold.svg')" alt="">
                                                                    <span :class="{'childrenlist': obj.childrenlist.length, 'taskname': !obj.childrenlist.length}">{{obj.taskname}}</span>
                                                                </div>
                                                                <div class="right" v-if="detailsData.isjoin === 1 && obj.exampaperinnerid">
                                                                    <!-- <div class="accuracy">{{obj.rightrate}}</div> -->
                                                                    <!-- <div class="count">{{obj.finishquescount}}/{{obj.quescount}}</div> -->
                                                                    <!-- <div class="btn"> -->
                                                                    <div v-if="obj.status === 0" class="doExercise" @click.stop="updateStartExam(obj)">做题</div>
                                                                    <div v-if="obj.status === 1" class="continue" @click.stop="updateStartExam(obj)">继续</div>
                                                                    <div v-if="obj.status === 11" class="doExercise" @click.stop="updateStartExam(obj)">重做</div>
                                                                    <!-- </div> -->
                                                                </div>
                                                            </div>
                                                        </template>
                                                        <div class="subjectItem" v-for="(options, j) in obj.childrenlist" :key="j">
                                                            <div class="taskname">{{options.taskname}}</div>
                                                            <div class="right" v-if="detailsData.isjoin === 1 && options.exampaperinnerid">
                                                                <!-- <div class="accuracy">{{options.rightrate}}</div>
                                                                <div class="count">{{options.finishquescount}}/{{options.quescount}}</div> -->
                                                                <div class="btn">
                                                                    <div v-if="options.status === 0" class="doExercise" @click="updateStartExam(options)">做题</div>
                                                                    <div v-if="options.status === 1" class="continue" @click="updateStartExam(options)">继续</div>
                                                                    <div v-if="options.status === 11" class="doExercise" @click="updateStartExam(options)">重做</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </el-collapse-item>
                                                </el-collapse>
                                            </div>
                                        </el-collapse-item>
                                    </el-collapse>
                                    <!-- <div class="cata_item_box" v-for="(item, index) in chapterData" :key="index">
                                        <p class="cata_title_text">
                                            <span>{{item.sectionname}}</span></p>
                                        <div v-if="item&&item.taskinfolist.length === 0" class="no_task_box">暂无章节任务</div>
                                        <div :class="detailsData.isjoin===1?'section_box sec_hover':'section_box'"  v-for="(subItem, subIndex) in item.taskinfolist" :key="subIndex">
                                            <div>
                                                <p></p>
                                                <p>{{subItem.taskname}}</p>
                                            </div>
                                            <div v-if="detailsData.isjoin===1">
                                                <div class="hover_box" @click="jumpText(subItem.innerid)">
                                                    <div><img :src="require('@/common/images/other/see_icon.png')" alt="">进入考试</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                            <!-- 资料 -->
                            <div v-show="menuIndex === 3" class="course_tabs_item_box data_warp">
                                <div class="material_item" v-for="(item, index) in material" :key="index">
                                    <div class="material_item_name">{{item.docname}}</div>
                                    <div class="material_item_btn" v-if="detailsData.isjoin">
                                        <div class="box" @click="download(item)">
                                            <img :src="require('@/common/images/other/download.png')" alt="">
                                            <span>下载资料</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bottom_right">
                        <div class="organ_info_box1">
                            <div class="box1">
                                <img @click="toOrganPage(detailsData.hostinfo.hostid,'题库')"
                                     v-lazy="detailsData.hostinfo.hostlogourl" alt="">
                                <div>
                                    <p @click="toOrganPage(detailsData.hostinfo.hostid,'题库')">
                                        {{detailsData.hostinfo.hostname}}</p>
                                    <img v-lazy="detailsData.hostinfo.hosttype === 2 ? require('@/common/images/organ/grrz.png') : require('@/common/images/organ/qyrz.png')" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="organ_info_box3">
                            <p class="tdkc">TA的题库</p>
                            <div v-if="detailsData.hostinfo.hostbanklist&&detailsData.hostinfo.hostbanklist.length > 0">
                                <div @click="bankClick(item.bankid)" class="kc_box"
                                     v-for="(item, index) in detailsData.hostinfo.hostbanklist" :key="index">
                                    <img v-lazy="item.coverurl" :alt="item.subject">
                                    <p>{{item.subject}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--推荐-->
            <div class="recommend_wrap">
                <p class="recommend_title_text">还为您推荐以下题库</p>
                <div v-if="recommendCourse&&recommendCourse.length > 0" class="recommend_course_box">
                    <div @click="bankClick(item.bankid)" class="course_item_div"
                         v-for="(item, index) in recommendCourse" :key="index">
                        <img v-lazy="item.coverurl" :alt="item.subject">
                        <div>
                            <p>{{item.subject}}</p>
                            <p><span>{{item.feetype === 1 ? '免费' : `￥${item.saleprice}`}}</span>{{item.joincount}}人参与
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--参与弹窗-->
        <transition name="fade">
            <div v-if="joinStudyPop" class="join_study_pop">
                <div class="join_study_box">
                    <img @click="closeJoinStudyPop()" class="close_icon"
                         :src="require('@/common/images/header/close.png')" alt="">
                    <img :src="require('@/common/images/other/other.png')" alt="">
                    <p>恭喜你已参与成功！快去考试吧</p>
                    <el-button @click="closeJoinStudyPop()" type="danger" round size="mini">好的</el-button>
                </div>
            </div>
        </transition>
        <ItemBankDialog ref="itemBankDialog"></ItemBankDialog>
        <el-dialog :visible.sync="getCouponDialog" :close-on-click-modal="false" :close-on-press-escape="false" width="456px" class="getCouponDialog">
            <div class="getCouponDialogContent">
                <img :src="require('@/common/images/course/success.png')" class="success" alt="">
                <p class="success_tips">优惠券领取成功</p>
                <p class="tips">个人中心可查看我的优惠券</p>
                <el-button @click="getCouponDialog = false">好的</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="getCouponFailDialog" :close-on-click-modal="false" :close-on-press-escape="false" width="290px" class="getCouponFailDialog">
            <div class="getCouponFailDialogContent">
                <p class="fail_tips">抱歉，当前优惠券限领{{astrictcount}}张！</p>
                <p class="tips">个人中心可查看我的优惠券</p>
                <el-button @click="getCouponFailDialog = false">好的</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="showCommonForm" :close-on-click-modal="false" :close-on-press-escape="false" width="240px" class="commonform">
            <div class="container">
                <img class="img" v-lazy="detailsData.naireUrl" alt="">
                <div class="tip">微信扫一扫参与问卷调查</div>
            </div>
        </el-dialog>
        <div class="fixed-box">
            <div class="box icon-quesnaire" v-if="detailsData.iscommonform" @click="openCommonFormDialog"></div>
            <div class="box icon_gotop" @click="gotoTop"></div>
        </div>
    </div>
</template>
<script>
    import {mapGetters,mapActions} from 'vuex'
    import {uploadCourseFavorite, getReceiveCouponVoucher} from 'api/api'
    import {getQuestionbankDetail,getQuestionbankTask,getRecommendQbankByDetail,uploadBankJoinInfo, getQBDoc, downloadDoc} from 'api/questionbank'
    import $ from 'jquery'
    import QRCode  from "qrcodejs2"
    import ItemBankDialog from 'views/pc/questionDetails/components/itemBankDialog' //引入弹窗
    import {urlToQRCode} from 'common/js/tools'
    export default {
        name: "QuestionDetails",
        data() {
            return {
                isSuccess: true, //数据是否加载完成
                menuIndex: 1, //导航
                detailsData: {
                    hostinfo: {},
                    iscommonform: 0
                },
                chapterData: [], //章节目录
                recommendCourse: [], // 底部推荐题库
                joinStudyPop: false, // 立即参与弹窗
                activeNames: [],
                timer: {
                    timer: null,
                    day: 0,
                    hour: 0,
                    minute: 0,
                    second: 0
                },
                getCouponDialog: false,
                getCouponFailDialog: false,
                astrictcount: 0,
                showCommonForm: false, // 问卷二维码
                material: [],
                getData: true
            }
        },
        created() {
            if(this.domainInfo.isMobile){
                if (this.$route.query.courseid) {
                    this.$router.push({
                        name: 'PaperDetails',
                        query: {
                            'qid': this.$route.query.qid,
                            'courseid': this.$route.query.courseid
                        }
                    })
                } else {
                    this.$router.push({
                        name: 'PaperDetails',
                        query: {
                            'qid': this.$route.query.qid
                        }
                    })
                }
            }
        },
        mounted() {
            this._getList();
            this.findRecommendCourseByDetail();
            this.$nextTick(() => {
                this.qRCode()
                this.qRCode2()
            })
        },
        methods: {
          gotoTop() {
            $('html').scrollTop(0)
          },
          openCommonFormDialog() {
            this.showCommonForm = true
          },
            // 领取优惠券
            getCoupon(item, index) {
                console.log(item, index)
                if (this.user.isLogin) {
                    if (item.inventory && (item.couponcount < item.countbyper || item.countbyper === 0)) {
                        this.setLoading(true)
                        getReceiveCouponVoucher({
                            data: {couponinnerid: item.couponvoucherid},
                            success: res => {
                                this.setLoading(false)
                                this.getCouponDialog = true
                                ++item.couponcount
                                item.inventory = res.data.inventory
                            },
                            error: res => {
                                this.setLoading(false)
                                this.$message.error(res.msg)
                            }
                        })
                    } else if (item.couponcount >= item.countbyper && item.countbyper !== 0) {
                        this.astrictcount = item.countbyper
                        this.getCouponFailDialog = true
                    }
                } else {
                    this.setLoginPop(true)
                }
            },
            updateStartExam(item) {
                this.getData = false
                this.$router.push({
                    name: 'ExaminationPaperInformation',query: {bankid: this.detailsData.bankid, taskid: item.innerid}
                })
            },
            // 页面跳转
            toIndex() {
                this.getData = false
                this.$router.push({name: 'Index'})
            },
            pageJump(code, titleText) {
                this.getData = false
                this.$router.push({name: 'Search', query: {typeData: code, title: titleText}})
            },
            //获取详情
            _getList() {
                this.setLoading(true);
                let params = {
                    bankid: this.$route.query.qid,
                    courseid: this.$route.query.courseid ? this.$route.query.courseid : ''
                };
                getQuestionbankDetail({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false);
                        this.isSuccess = false;
                        // data.data.hostinfo.hosttype = 1

                        if (data.data.comonformshareurl) data.data.naireUrl = urlToQRCode(data.data.comonformshareurl)
                        this.detailsData = data.data;
                        if (this.detailsData.islimitcount && this.detailsData.endtime) {
                            let endtime = new Date(this.detailsData.endtime).getTime()
                            if (this.timer.timer) clearInterval(this.timer.timer)
                                this.timer.timer = setInterval(() => {
                                this._initTimer(endtime)
                            }, 1000)
                        }
                        document.title=this.detailsData.subject
                        if (this.detailsData.ishavedoc) {
                            this.getQBDoc()
                        }
                        // this.$nextTick(() => {
                        //     this.qRCode()
                        //     this.qRCode2()
                        // })
                    },
                    error: data => {
                        this.isSuccess = true;
                        this.$message.error(data.msg)
                    }
                })
            },
            _initTimer(endtime) {
                let current = new Date().getTime()
                let time = (endtime - current ) / 1000
                this.timer.day = parseInt(time / 3600 / 24)
                this.timer.hour = parseInt(time / 3600) % 24 < 10 ? '0' + parseInt(time / 3600) % 24 : parseInt(time / 3600) % 24
                this.timer.minute = parseInt(time /60) % 60 < 10 ? '0' + parseInt(time /60) % 60 : parseInt(time /60) % 60
                this.timer.second = parseInt(time % 60) < 10 ? '0' + parseInt(time % 60) : parseInt(time % 60)
            },
            getQBDoc() {
                this.setLoading(true)
                getQBDoc({
                    data: {qbid: this.$route.query.qid, ispage: 0, page: 0, pagesize: 0},
                    success: res => {
                        this.setLoading(false)
                        this.material = res.data.content
                    },
                    error: res => {
                        this.setLoading(false)
                        this.$message.error(res.msg)
                    }
                })
            },
            download(item) {
                this.setLoading(true)
                downloadDoc({
                    data: {innerid: item.innerid},
                    name: item.orgfilename,
                    success: res => {
                        console.log(res)
                        this.setLoading(false)
                    },
                    error: res => {
                        this.setLoading(false)
                        this.$message.error(res.msg)
                    }
                })
            },
            // 获取章节目录
            findCourseTask() {
                this.setLoading(true);
                let params = {
                    bankid: this.$route.query.qid
                };
                getQuestionbankTask({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false);
                        data.data.content.forEach((item) => {
                            item.activeNames = []
                            item.taskinfolist.forEach(obj => {
                                obj.activeNames = []
                            })
                        })
                        this.chapterData = data.data.content;
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg)
                    }
                })
            },
            // 获取推荐题库（题库详情）
            findRecommendCourseByDetail() {
                this.setLoading(true)
                let params = {}
                getRecommendQbankByDetail({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false)
                        this.recommendCourse = data.data.content
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            qRCode() { // 分享二维码生成
                new QRCode('qrcodeUrl', {
                    width: 100,
                    height: 100, // 高度
                    text: window.location.origin+'/m/PaperDetails?qid='+this.$route.query.qid,   // 二维码内容
                })
            },
            qRCode2() { // 手机学习二维码生成
                new QRCode('qrcodeUrl2', {
                    width: 100,
                    height: 100, // 高度
                    text: window.location.origin+'/m/PaperDetails?qid='+this.$route.query.qid,   // 二维码内容
                })
            },
            // 导航点击
            menuClick(val) {
                this.menuIndex = val;
                if (val === 2) {
                    this.findCourseTask()
                }
            },
            // 题库点击
            bankClick(id) {
                this.$router.push({name: 'QuestionDetails', query: {'qid': id}})
            },
            // 参与题库（免费有效）
            joinQuestion() {
                this.setLoading(true)
                let params = {
                    bankid: this.$route.query.qid
                }
                uploadBankJoinInfo({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false)
                        console.log(data.data)
                        this.joinStudyPop = true
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            // 关闭参与成功弹窗
            closeJoinStudyPop() {
                this.joinStudyPop = false;
                this.detailsData.isjoin = 1
            },
            // 立即购买
            buyNow() {
                // this.$router.push({name: 'OrderIndex', query: {'qid': this.detailsData.bankid, kmctype: 8}})
                this.getData = false
                this.$router.push({name: 'OrderIndex', query: {'kmcinnerid': this.detailsData.bankid, kmctype: 8}})
            },
            // 进入考试
            jumpText(taskid) {
                this.getData = false
                this.$router.push({
                    name: 'ExaminationPaperInformation',
                    query: {bankid: this.detailsData.bankid, taskid: taskid}
                })
            },
            // 考试弹窗
            clickTestPaperPopu() {
                if(this.detailsData.qbtype===2){ //系列试卷
                    let params = {
                        bankid: this.$route.query.qid
                    };
                    getQuestionbankTask({
                        data: Object.assign({}, params),
                        success: data => {
                            data.data.content.forEach((item) => {
                                item.activeNames = []
                                item.taskinfolist.forEach(obj => {
                                    obj.activeNames = []
                                })
                            })
                            this.chapterData = data.data.content;
                            this.$refs.itemBankDialog.startItemBankDialog(this.detailsData.bankid,this.chapterData)
                        },
                        error: data => {
                            this.$message.error(data.msg)
                        }
                    })
                }else{ //单试卷
                    this.getData = false
                    this.$router.push({name: 'ExaminationPaperInformation', query: {bankid: this.detailsData.bankid,taskid:0}})
                }
            },
            // 收藏课程
            collectionClick(val) {
                this.setLoading(true);
                let params = {
                    courseid: this.$route.query.qid ? this.$route.query.qid : 'OLLII3p9KBWhHTuZ',
                    optype: val === 1 ? 2 : 1,
                    kmctype: 8,
                }
                uploadCourseFavorite({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false)
                        if (data.code === '000') {
                            if (val === 1) {
                                this.detailsData.isfavorite = 0
                                this.$message.success('已取消收藏')
                            } else {
                                this.detailsData.isfavorite = 1
                                this.$message.success('收藏成功')
                            }
                        }
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            // 跳转到机构页面
            toOrganPage(organId, val) {
                this.getData = false
                if (val === '题库') {
                    this.$router.push({name: 'OrganIndex', query: {'hostid': organId, 'tabs': '5'}})
                } else {
                    this.$router.push({name: 'OrganIndex', query: {'hostid': organId}})
                }
            },
            // 回到顶部
            goTop() {
                $("html,body").animate({
                    scrollTop: 0
                }, 400)
            },
            ...mapActions([
                'setLoading',
                'setLoginPop',
                'setUser'
            ])
        },
        watch: {
            $route: function (newVal, oldVal) {
                // console.log(oldVal); //oldVa 上一次url
                // console.log(newVal); //newVal 这一次的url
                if (newVal != oldVal) {
                    this.menuIndex = 1
                    this.detailsData = {
                        hostinfo: {}
                    }
                    this.chapterData = []
                    this.recommendCourse = [] // 底部推荐题库
                    if (this.getData) {
                        this._getList()
                        this.findRecommendCourseByDetail()
                    }
                    this.goTop()
                }
            },
            user: function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.menuIndex = 1
                    this.detailsData = {
                        hostinfo: {}
                    }
                    this.chapterData = []
                    this.recommendCourse = [] // 底部推荐题库
                    if (this.getData) {
                        this._getList()
                        this.findRecommendCourseByDetail()
                    }
                    this.goTop()
                }
            }
        },
        computed: {
            ...mapGetters(['loginPop', 'user','domainInfo'])
        },
      beforeRouteLeave(to, from , next) {
        clearInterval(this.timer.timer)
        next()
      },
        components: {
            ItemBankDialog
        }
    }
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .QuestionDetails_wrap {
        // margin-top: 80px;
        display: flex;
        flex-direction: column;
        color: #333;
        height: 100%;
        .QuestionDetails {
            border-bottom: 2px solid rgba(229, 229, 229, 0.5);
            background: #f8f8f8;
            padding-bottom: 40px;
            .question_top_wrap {
                background: #fff;
                border-bottom: 0.02667rem solid rgba(229, 229, 229, 0.5);
                .question_top_main {
                    padding: 30px 0 30px 40px;
                    width: 1200px;
                    box-sizing: border-box;
                    margin: 0 auto;
                    .top_nav {
                        padding-bottom: 30px;
                        display: flex;
                        .jump_text {
                            cursor: pointer;
                        }
                        .jump_text:hover {
                            color: #409EFF;
                        }
                        span {
                            margin: 0 8px;
                        }
                    }
                    .top_info {
                        display: flex;
                        align-items: center;
                        .top_left {
                            width: 460px;
                            height: 262px;
                            box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
                            margin-right: 40px;
                            border-radius: 10px;
                            overflow: hidden;
                            img {
                                width: 460px;
                                height: 262px;
                            }
                        }
                        .top_right {
                            width: 640px;
                            min-height: 262px;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            .queInfo_box {
                                .title {
                                    font-size: 20px;
                                    line-height: 28px;
                                    font-weight: bold;
                                    margin-bottom: 10px;
                                }
                                .subTitle {
                                    line-height: 20px;
                                    color: #999;
                                    margin-bottom: 20px;
                                }
                                .coupon {
                                    display: flex;
                                    // align-items: center;
                                    // margin-bottom: 22px;
                                    .name {
                                        font-size: 12px;
                                        color: #666666;
                                        margin-right: 20px;
                                        white-space: nowrap;
                                    }
                                    .list {
                                        display: flex;
                                        align-items: center;
                                        flex-wrap: wrap;
                                        .getLabel {
                                            padding: 2px 10px;
                                            font-size: 12px;
                                            color: #FF4747;
                                            background: #FFE8E8;
                                            margin-bottom: 10px;
                                            margin-right: 10px;
                                            border: 1px solid #FFE8E8;
                                        }
                                        .item {
                                            padding: 2px 10px;
                                            cursor: pointer;
                                            font-size: 12px;
                                            color: #FF4747;
                                            background: #FFE8E8;
                                            margin-bottom: 10px;
                                            border: 1px solid #FF4747;
                                            box-sizing: border-box;
                                            &:not(:last-of-type) {
                                                margin-right: 10px;
                                            }
                                        }
                                    }
                                }
                                .money {
                                    line-height: 28px;
                                    color: #FF4747FF;
                                    font-size: 20px;
                                    margin-right: 10px;
                                    .uprice {
                                        color: #999;
                                        font-size: 14px;
                                        text-decoration: line-through;
                                    }
                                    b {
                                        color: #FF4747FF;
                                        font-size: 20px;
                                    }
                                }
                                .el-button {
                                    width: 160px;
                                    height: 40px;
                                    margin-top: 20px;
                                    margin-bottom: 20px;
                                    background: #FF4747FF;
                                    font-size: 16px;
                                    border-radius: 24px;
                                }
                                .el-button:hover {
                                    background: rgb(238, 106, 106);
                                }
                                .el-button:active {
                                    background: rgb(241, 154, 154);
                                }
                            }
                            .right_bottom_box {
                                height: 24px;
                                display: flex;
                                align-items: center;
                                font-size: 12px;
                                span {
                                    color: #999;
                                    white-space: nowrap;
                                }
                                .line {
                                    color: #e5e5e5;
                                    margin: 0 10px;
                                }
                                .cursor_class {
                                    cursor: pointer;
                                    display: flex;
                                    align-items: center;
                                    & > img {
                                        width: 16px;
                                        height: 16px;
                                        margin-right: 4px;
                                    }
                                }
                                .is_enshrine {
                                    color: #409EFFFF;
                                }
                                .enshrine:hover {
                                    color: #409EFFFF;
                                }
                            }
                        }
                    }
                }
            }
            /*下面部分*/
            .question_bottom_wrap {
                background: rgba(248, 248, 248, 1);
                display: flex;
                .bottom_box {
                    width: 1200px;
                    margin: 20px auto;
                    display: flex;
                    justify-content: space-between;
                    .bottom_left {
                        width: 900px;
                        min-height: 200px;
                        /*background: #fff;*/
                        .que_main {
                            background: #fff;
                            .course_tabs_item_box {
                                // padding: 30px;
                                font-size: 14px;
                                .no_data_box {
                                    display: flex;
                                    flex-direction: column;
                                    align-items: center;
                                    & > img {
                                        width: 130px;
                                        height: 76px;
                                        margin-bottom: 20px;
                                    }
                                    & > span {
                                        color: #CADAEEFF;
                                        line-height: 20px;
                                    }
                                }
                                .page_box {
                                    display: flex;
                                    justify-content: center;
                                    padding-bottom: 10px;
                                }
                            }
                            .tabs_box {
                                height: 60px;
                                display: flex;
                                align-items: center;
                                border-bottom: 1px solid rgba(229, 229, 229, 0.5);
                                & > div {
                                    position: relative;
                                    padding: 10px 0;
                                    box-sizing: border-box;
                                    cursor: pointer;
                                    font-size: 16px;
                                    font-weight: bold;
                                    margin-left: 90px;
                                    color: #333;
                                    -moz-user-select: none; /* Firefox私有属性 */
                                    -webkit-user-select: none; /* WebKit内核私有属性 */
                                    -ms-user-select: none; /* IE私有属性(IE10及以后) */
                                    -khtml-user-select: none; /* KHTML内核私有属性 */
                                    -o-user-select: none; /* Opera私有属性 */
                                    user-select: none; /* CSS3属性 */
                                    & > span, & > label {
                                        font-size: 10px;
                                        color: #999;
                                        line-height: 14px;
                                        position: absolute;
                                        top: -4px;
                                        left: 66px;
                                    }
                                    & > label {
                                        color: #FFF;
                                        text-align: center;
                                        padding: 2px 5px;
                                        white-space: nowrap;
                                        background-color: #FF4747FF;
                                        border-radius: 10px;
                                        top: -6px;
                                    }
                                }
                                & > div:hover {
                                    color: #409EFFFF;
                                }
                                & > div:nth-of-type(1) {
                                    margin-left: 30px;
                                }
                                & > div::before {
                                    content: '';
                                    width: 1px;
                                    height: 20px;
                                    background-color: rgba(229, 229, 229, 1);
                                    position: absolute;
                                    bottom: 6px;
                                    right: -46px;
                                }
                                & > div:nth-last-of-type(1)::before {
                                    width: 0;
                                    height: 0;
                                }
                                .menuIndex3 {
                                    padding-left: 15px;
                                }
                                .active {
                                    color: #409EFFFF;
                                }
                                .active::after {
                                    content: '';
                                    width: 24px;
                                    height: 3px;
                                    background-color: #409EFF;
                                    position: absolute;
                                    bottom: -4px;
                                    left: 20px;
                                }

                            }
                            /*题库介绍*/
                            .introduce_warp {
                                padding: 20px;
                                .no_data_box {
                                    padding: 10px;
                                }
                                .introduce_box {
                                    * {
                                        font-size: 14px;
                                        max-width: 100%;
                                        line-height: 28px;
                                    }
                                }
                            }
                            /*章节目录*/
                            .cata_warp {
                                .no_data_box {
                                    padding: 30px;
                                }
                                .cata_box {
                                    .cata_item_box {
                                        margin-bottom: 20px;
                                        .cata_title_text {
                                            font-size: 14px;
                                            line-height: 20px;
                                            color: rgba(51, 51, 51, 1);
                                            margin-bottom: 20px;
                                            display: flex;
                                            justify-content: space-between;
                                            & > span:nth-of-type(1) {
                                                font-weight: bold;
                                            }
                                            & > span:nth-of-type(2) {
                                                color: #999;
                                            }
                                        }
                                        .no_task_box {
                                            height: 40px;
                                            line-height: 40px;
                                            color: #999;
                                            padding: 0 20px;
                                        }
                                        .section_box {
                                            padding: 0 12px;
                                            height: 40px;
                                            margin-bottom: 6px;
                                            display: flex;
                                            justify-content: space-between;
                                            align-items: center;
                                            background: rgba(248, 248, 248, 1);
                                            & > div:nth-of-type(1) {
                                                display: flex;
                                                & > p:nth-of-type(1) {
                                                    // width: 53px;
                                                    width: 0px;
                                                    color: #999;
                                                }
                                                & > p:nth-of-type(2) {
                                                    width: 660px;
                                                    white-space: nowrap;
                                                    text-overflow: ellipsis;
                                                    overflow: hidden;
                                                    word-break: break-all;
                                                }
                                            }
                                            & > div:nth-of-type(2) {
                                                .no_hover_box {
                                                    display: flex;
                                                    & > img {
                                                        width: 14px;
                                                        height: 14px;
                                                        margin-right: 10px
                                                    }
                                                    & > p {
                                                        width: 32px;
                                                        color: #999;
                                                    }
                                                }
                                                .hover_box {
                                                    display: none;
                                                    color: #409EFF;
                                                    & > div {
                                                        display: flex;
                                                        & > img {
                                                            width: 14px;
                                                            height: 14px;
                                                            margin-right: 6px
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        .section_box:nth-last-of-type(1) {
                                            margin-bottom: 0;
                                        }
                                        .sec_hover:hover {
                                            cursor: pointer;
                                            background: rgba(241, 248, 255, 1);
                                            & > div:nth-of-type(2) {
                                                .no_hover_box {
                                                    display: none;
                                                }
                                                .hover_box {
                                                    display: flex;
                                                }
                                            }
                                        }
                                    }
                                    .cata_item_box:nth-last-of-type(1) {
                                        margin-bottom: 0;
                                    }
                                    .outside {
                                        border: none;
                                        padding-bottom: 60px;
                                        .outsideItem {
                                            border: none;
                                            .el-collapse-item__header {
                                                border: none;
                                                // border-bottom: 1px solid #E5E5E5;
                                                height: 56px;
                                            }
                                            .el-collapse-item__wrap {
                                                border-bottom: none;
                                                .el-collapse-item__content {
                                                    padding-bottom: 0;
                                                }
                                            }
                                            .itemTitle {
                                                display: flex;
                                                align-items: center;
                                                font-size: 14px;
                                                padding-left: 30px;
                                                width: 100%;
                                                border-bottom: 1px solid #E5E5E5;
                                                img {
                                                    margin-right: 12px;
                                                }
                                                .sectionname {
                                                    margin-left: 32px;
                                                }
                                                .taskname {
                                                    margin-left: 34px;
                                                }
                                            }
                                            .el-collapse-item__arrow {
                                                display: none;
                                            }
                                            .inside {
                                                border: none;
                                                .el-collapse-item__header {
                                                    .insideItemTitle {
                                                        border-bottom: 1px solid #E5E5E5;
                                                        width: 100%;
                                                        padding-left: 50px;
                                                        display: flex;
                                                        justify-content: space-between;
                                                        align-items: center;
                                                        .left {
                                                            display: flex;
                                                            .taskname {
                                                                margin-left: 32px;
                                                            }
                                                            img {
                                                                margin-right: 12px;
                                                            }
                                                        }
                                                        .right {
                                                            padding-right: 10px;
                                                            .continue {
                                                                width: 80px;
                                                                height: 32px;
                                                                border: 3px solid #FFECD4;
                                                                background: #F18B05;
                                                                color: #fff;
                                                                text-align: center;
                                                                line-height: 26px;
                                                                box-sizing: border-box;
                                                                font-size: 14px;
                                                                border-radius: 4px;
                                                            }
                                                            .doExercise {
                                                                width: 80px;
                                                                height: 32px;
                                                                border: 3px solid #DFECFD;
                                                                background: #409EFF;
                                                                color: #fff;
                                                                text-align: center;
                                                                line-height: 26px;
                                                                box-sizing: border-box;
                                                                font-size: 14px;
                                                                border-radius: 4px;
                                                            }
                                                        }
                                                    }
                                                }
                                                .el-collapse-item__content {
                                                    padding-bottom: 1px;
                                                }
                                                .subjectItem {
                                                    padding-left: 98px;
                                                    display: flex;
                                                    justify-content: space-between;
                                                    align-items: center;
                                                    height: 56px;
                                                    border-bottom: 1px solid #E5E5E5;
                                                    .taskname {
                                                        color: #333333;
                                                        font-size: 14px;
                                                    }
                                                    .right {
                                                        padding-right: 10px;
                                                        .continue {
                                                            width: 80px;
                                                            height: 32px;
                                                            border: 3px solid #FFECD4;
                                                            background: #F18B05;
                                                            color: #fff;
                                                            text-align: center;
                                                            line-height: 26px;
                                                            box-sizing: border-box;
                                                            font-size: 14px;
                                                            border-radius: 4px;
                                                            cursor: pointer;
                                                        }
                                                        .doExercise {
                                                            width: 80px;
                                                            height: 32px;
                                                            border: 3px solid #DFECFD;
                                                            background: #409EFF;
                                                            color: #fff;
                                                            text-align: center;
                                                            line-height: 26px;
                                                            box-sizing: border-box;
                                                            font-size: 14px;
                                                            border-radius: 4px;
                                                            cursor: pointer;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            // 资料样式
                            .data_warp {
                                padding: 30px;
                                .material_item {
                                    display: flex;
                                    align-items: center;
                                    justify-content: space-between;
                                    background: #F8F8F8;
                                    margin-bottom: 6px;
                                    height: 40px;
                                    padding: 0 20px;
                                    font-size: 14px;
                                    .material_item_btn {
                                        color: #409EFF;
                                        display: none;
                                        .box {
                                            cursor: pointer;
                                            display: flex;
                                            align-items: center;
                                            img {
                                                // padding-top: 20px;
                                                width: 18px;
                                                height: 18px;
                                                margin-right: 6px;
                                                display: inline-block;
                                            }
                                        }
                                    }
                                    &:hover {
                                        background: #F1F8FF;
                                        .material_item_btn {
                                            display: block;
                                        }
                                    }
                                }
                            }
                            /*题库无介绍时样式*/
                            .no_data_box {
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                & > img {
                                    width: 130px;
                                    height: 76px;
                                    margin-bottom: 20px;
                                }
                                & > span {
                                    color: #CADAEEFF;
                                    line-height: 20px;
                                }
                            }
                        }
                    }
                    .bottom_right {
                        width: 280px;
                        min-height: 236px;
                        .organ_info_box1 {
                            margin-bottom: 12px;
                            // min-height: 160px;
                            background-color: #fff;
                            padding: 16px;
                            .box1 {
                                display: flex;
                                & > img {
                                    width: 60px;
                                    height: 60px;
                                    margin-right: 10px;
                                    cursor: pointer;
                                }
                                & > div {
                                    & > p {
                                        line-height: 22px;
                                        font-size: 16px;
                                        color: #409EFF;
                                        margin-bottom: 6px;
                                        cursor: pointer;
                                    }
                                    & > img {
                                        width: 75px;
                                        height: 26px;
                                    }
                                }
                            }
                            .box2 {
                                display: flex;
                                align-items: center;
                                padding: 16px 0;
                                & > div {
                                    cursor: pointer;
                                    display: flex;
                                    flex: 1;
                                    flex-direction: column;
                                    justify-content: center;
                                    & > p {
                                        line-height: 17px;
                                        color: #666;
                                        font-size: 12px;
                                        margin-bottom: 4px;
                                        text-align: center;
                                    }
                                    & > span {
                                        color: #409EFF;
                                        font-size: 14px;
                                        line-height: 20px;
                                        text-align: center;
                                    }
                                }
                                & > label {
                                    // padding: 0 1px;
                                    width: 1px;
                                    height: 21px;
                                    background-color: #E5E5E5;
                                    // background-color: rgb(253, 0, 0)
                                }
                            }
                            .box3 {
                                color: #666;
                                font-size: 12px;
                                padding-top: 16px;
                                border-top: 1px solid #F5F5F5;
                                line-height: 17px;
                            }
                        }
                        .organ_info_box2 {
                            background-color: #fff;
                            // min-height: 100px;
                            padding: 16px;
                            margin-bottom: 12px;
                            display: flex;
                            position: relative;
                            cursor: pointer;
                            & > img {
                                width: 80px;
                                height: 80px;
                                margin-right: 15px;
                            }
                            & > div {
                                height: 80px;
                                display: flex;
                                flex-direction: column;
                                justify-content: center;
                                & > P:nth-of-type(1) {
                                    font-size: 16px;
                                    line-height: 20px;
                                    color: #333;
                                    margin-bottom: 10px;
                                }
                                & > P:nth-of-type(2) {
                                    line-height: 17px;
                                    font-size: 12px;
                                    color: #999;
                                }
                            }
                        }
                        .organ_info_box3 {
                            padding: 16px;
                            background-color: #fff;
                            min-height: 300px;
                            .tdkc {
                                line-height: 20px;
                            }
                            .kc_box {
                                margin-top: 10px;
                                padding-bottom: 10px;
                                border-bottom: 1px solid #F5F5F5;
                                overflow: hidden;
                                border-radius: 4px;
                                cursor: pointer;
                                & > img {
                                    border-radius: 4px;
                                    width: 248px;
                                    height: 140px;
                                    margin-bottom: 10px;
                                }
                                & > p {
                                    line-height: 20px;
                                    text-align: justify;
                                    padding: 0 4px;
                                    text-overflow: -o-ellipsis-lastline;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    display: -webkit-box;
                                    -webkit-line-clamp: 2;
                                    line-clamp: 2;
                                    -webkit-box-orient: vertical;
                                }
                            }
                            .kc_box:nth-last-of-type(1) {
                                border-bottom: none;
                            }
                            .kc_box:hover {
                                transition: all .3s;
                                -moz-transition: all .3s;
                                -o-transition: all .3s;
                                -ms-transition: all .3s;
                                -webkit-transition: all .3s;
                                box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
                                -moz-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
                                -o-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
                                -ms-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
                                -webkit-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
                            }
                        }
                    }
                }
            }
            /*推荐部分*/
            .recommend_wrap {
                width: 1200px;
                margin: 0 auto;
                .recommend_title_text {
                    padding: 0 10px;
                    margin: 0 0 30px 0;
                    font-size: 20px;
                    line-height: 28px;
                    color: #666;
                }
                .recommend_course_box {
                    padding: 0 10px;
                    min-height: 200px;
                    display: flex;
                    flex-wrap: wrap;
                    .course_item_div {
                        margin-right: 12px;
                        margin-bottom: 20px;
                        cursor: pointer;
                        width: 226px;
                        border-radius: 4px;
                        display: flex;
                        flex-direction: column;
                        & > img {
                            width: 226px;
                            height: 118px;
                            border-radius: 4px;
                            margin-bottom: 10px;
                        }
                        & > div {
                            flex: 1;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            & > p {
                                text-align: justify;
                                padding: 0 4px;
                                font-size: 16px;
                                line-height: 20px;
                                // font-weight: bold;
                                text-overflow: -o-ellipsis-lastline;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                line-clamp: 2;
                                -webkit-box-orient: vertical;
                            }
                            & > p:nth-of-type(2) {
                                padding: 10px 4px;
                                font-weight: normal;
                                color: #999;
                                font-size: 12px;
                                & > span {
                                    font-size: 14px;
                                    color: #FF4747FF;
                                    margin-right: 10px;
                                }
                            }
                        }
                    }
                    .course_item_div:nth-of-type(5n) {
                        margin-right: 0;
                    }
                    .course_item_div:hover {
                        transition: all .3s;
                        -moz-transition: all .3s;
                        -o-transition: all .3s;
                        -ms-transition: all .3s;
                        -webkit-transition: all .3s;
                        box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
                        -moz-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
                        -o-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
                        -ms-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
                        -webkit-box-shadow: 0 0 8px 1px rgba(0, 0, 0, .2);
                    }
                }
            }
        }
        /*参与成功弹窗*/
        .join_study_pop {
            position: fixed;
            top: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.3);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 2000;
            & > div {
                position: relative;
                border-radius: 4px;
                background: rgba(255, 255, 255, 1);
                .close_icon {
                    cursor: pointer;
                    position: absolute;
                    right: 11px;
                    top: 10px;
                    width: 12px !important;
                    height: 12px !important;
                }
            }
            .join_study_box {
                width: 375px;
                height: 218px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                & > img {
                    width: 51px;
                    height: 54px;
                }
                & > p {
                    font-size: 16px;
                    line-height: 22px;
                    margin-top: 19px;
                    margin-bottom: 26px;
                }
                .el-button--mini, .el-button--small {
                    font-size: 16px;
                    width: 162px;
                }

            }
        }
        .limit-time{
            width: 560px;
            margin-bottom: 10px;
            .limit-time-header{
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 16px;
                height: 36px;
                background: linear-gradient(24deg, #FF4952 0%, #FF8047 100%);
                color: #fff;
                font-size: 14px;
                .left{
                    flex-grow: 1;
                    display: flex;
                    align-items: center;
                    .icon:before{
                        width: 16px;
                        height: 17px;
                        margin-right: 10px;
                    }
                }
                .right{
                    display: flex;
                    align-items: center;
                    .time-box{
                        width: 20px;
                        min-width: 20px;
                        height: 20px;
                        background: #FFFFFF;
                        border-radius: 4px;
                        color: #EC5E69;
                        font-size: 12px;
                        text-align: center;
                        line-height: 20px;
                    }
                    .sepa-l{
                        margin-left: 4px;
                    }
                    .sepa-r{
                        margin-right: 4px;
                    }
                }
            }
            .limit-time-body{
                display: flex;
                align-items: center;
                height: 48px;
                padding: 0 16px;
                .label{
                    color: #999999;
                    font-size: 12px;
                }
                .saleprice{
                    color: #FF4747;
                    font-size: 20px;
                    margin: 0 10px;
                }
                .uprice{
                    color: #999999;
                    font-size: 14px;
                    text-decoration: line-through;
                }
            }
            .limit-time-footer{
                padding: 0 16px 16px 16px;
                .el-button{
                    margin: 0 !important;
                }
            }
        }
        .fixed-box{
            position: fixed;
            bottom: 150px;
            right: 30px;
            z-index: 10;
            .box{
                background: #FFFFFF;
                box-shadow: 0 0 4px 0 rgba(0,0,0,0.10);
                border-radius: 4px;
                overflow: hidden;
                &:before{
                    display: block;
                    width: 45px;
                    height: 45px;
                }
            }
            .box+.box{
                margin-top: 8px;
            }
        }
    }
    .icon_popover_box {
        #qrcodeUrl, #qrcodeUrl2{
            margin-bottom: 6px;
        }
    }
    .page-footer{
        margin-top: 0;
    }
.getCouponDialog {
    .el-dialog__body {
        padding: 20px 40px 40px;
        .getCouponDialogContent {
            text-align: center;
            .success {
                width: 44px;
                height: 44px;
                margin: auto;
                margin-bottom: 14px;
            }
            .success_tips {
                font-size: 16px;
                margin-bottom: 4px;
                line-height: 22px;
            }
            .tips {
                font-size: 14px;
                color: #999999;
                margin-bottom: 30px;
                line-height: 20px;
            }
            .el-button {
                width: 100px;
                height: 30px;
                background: #409EFF;
                line-height: 30px;
                color: #fff;
                padding: 0;
            }
        }
    }
}
.getCouponFailDialog {
    .el-dialog__body {
        padding: 10px 20px 30px;
    }
    .getCouponFailDialogContent {
        text-align: center;
        .fail_tips {
            font-size: 16px;
            color: #EC5E69;
            line-height: 22px;
            margin-bottom: 4px;
        }
        .tips {
            font-size: 14px;
            color: #999999;
            line-height: 20px;
            margin-bottom: 20px;
        }
        .el-button {
            width: 100px;
            height: 30px;
            background: #409EFF;
            line-height: 30px;
            color: #fff;
            padding: 0;
        }
    }
}
.commonform{
    .el-dialog__body{
        padding-top: 10px;
    }
    .container{
        color: #333;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .img{
            width: 140px;
            height: 140px;
            margin-bottom: 10px;
        }
    }
}
</style>